/// <reference types="knockout">

var AbstractViewModel = require("./AbstractViewModel")
var Store = require("../helpers/Store")
var EventListener = require("../helpers/EventListener")
var UserPreferences = require("../helpers/UserPreferences")
var ActiveServiceTransactionsWS = require("../ws/ActiveServiceTransactionsWS")
var AuthInfoWS = require("../ws/AuthInfoWS")
var CheckStationWS = require("../ws/CheckStationWS")
var ConsumerExternalProfileWS = require("../ws/ConsumerExternalProfileWS")
var ConsumerInfoNotesWS = require("../ws/ConsumerInfoNotesWS")
var EmployeesWS = require("../ws/EmployeesWS")
var EndServiceTransactionWS = require("../ws/EndServiceTransactionWS")
var EnterQueueWS = require("../ws/EnterQueueWS")
var EventsWS = require("../ws/EventsWS")
var HeartbeatWS = require("../ws/HeartbeatWS")
var LocationsWS = require("../ws/LocationsWS")
var MessagesWS = require("../ws/MessagesWS")
var QueuesWS = require("../ws/QueuesWS")
var ServiceTransactionStartWS = require("../ws/ServiceTransactionStartWS")
var StationUpdateWS = require("../ws/StationUpdateWS")
var UpdateAppointmentStatusWS = require("../ws/UpdateAppointmentStatusWS")
var VariancesWS = require("../ws/VariancesWS")
var WssidWS = require("../ws/WssidWS")
var IssueTicketOverrideWS = require("../ws/IssueTicketOverrideWS")
var CallAheadWS = require("../ws/CallAheadWS")
var UpdateConsumerInfoWS = require("../ws/UpdateConsumerInfoWS")

var QueueModel = require("../models/QueueModel")
var SpotModel = require("../models/SpotModel")

var AddConsumerViewModel = require("../viewmodels/AddConsumerViewModel");
var BeginServiceViewModel = require("../viewmodels/BeginServiceViewModel");
var CheckInServicedViewModel = require("../viewmodels/CheckInServicedViewModel");
var ExternalResourcesViewModel = require("../viewmodels/ExternalResourcesViewModel");
var ForecastOverrideViewModel = require("../viewmodels/ForecastOverrideViewModel");
var ListViewModel = require("../viewmodels/ListViewModel");
var LocationSelectionViewModel = require("../viewmodels/LocationSelectionViewModel");
var ReleaseNotesViewModel = require("../viewmodels/ReleaseNotesViewModel");
var ServiceResultViewModel = require("../viewmodels/ServiceResultViewModel");
var ConsumerDetailViewModel = require("../viewmodels/ConsumerDetailViewModel");
var QueueSelectionViewModel = require("../viewmodels/QueueSelectionViewModel");
var SettingsViewModel = require("../viewmodels/SettingsViewModel");
var SearchViewModel = require("../viewmodels/SearchViewModel");
var ServicingViewModel = require("../viewmodels/ServicingViewModel");

var QueueWatcher = require("../helpers/QueueWatcher")
var showQueueNotification = require("../helpers/Notifications/Notifications").showQueueNotification
var DisplayPhone = require("../lib/display-phone")
var IdleWatcher = require("../lib/idle-watcher")

/**
 * @class
 */
function ViewModel() {
  var self = this;

  // Predicate this ViewModel on the Abstract class of a View Model
  // This tacks on additional functionality, including the ability to
  // read URL query parameters, and an observable binding predicated
  // on another object's obcervable-bound variables
  AbstractViewModel.apply(this, arguments);

  // Instance of a Store object, which stores data either in
  // LocalStorage or a cookie
  self.store = new Store();

  self.eventListener = new EventListener(self);
  self.userPreferences = new UserPreferences(self.store);

  // Collection of appointment statuses
  self.appointmentStatuses = ko.observableArray(['PENDING', 'APPROVED', 'REJECTED']);
  // The value passed in as a barcode
  self.barcode = ko.observable(null);
  // Whether the clear all consumers from Queue dialogue is visible
  self.confirmClearVisible = ko.observable(false);
  // ID of the queue which is currently being asked to be cleared
  self.clearQueue = ko.observable(null);
  // The currently in-service consumer
  // self.currentlyServicing				      = ko.observableArray( [] );
  // The session ID of the end service consumer
  self.endServiceSessionId = ko.observable(null);
  // Observables for the error dialogue
  self.errorTitle = ko.observable('Error');
  self.errorMessage = ko.observable(null);
  // Holds a collection of Feature Toggles loaded from the MessagesWS
  self.featureToggles = ko.observable({});
  // How much to increment/decrement the forecast each time
  self.forecastStep = 5;
  self.isLoading = ko.observable(false);
  // Tells us the direction the application text is read. RTL(Right to Left)
  self.isRTL = ko.observable(false);

  var audioroot = '/cec/res/audio/';

  /**
   * @typedef {object} NotificationSound
   * @property {string} name
   * @property {string} path
   */

  /**
   * @typedef {Array<NotificationSound>} NotificationSounds
   */

  /**
   * @type {KnockoutComputed<NotificationSounds>}
   */
  self.notificationSounds = ko.observableArray([
    { name: 'Doorbell', path: audioroot + 'doorbell.mp3' },
    { name: 'Bell 1', path: audioroot + 'ding1.mp3' },
    { name: 'Bell 2', path: audioroot + 'ding2.mp3' },
    { name: 'Bell 3', path: audioroot + 'ding3.mp3' }
  ]);
  // Sound to use when the doorbell method is called
  self.notificationSound = ko.observable(null);
  // Holds the notes that come back from the server
  self.selectedConsumerNotes = ko.observable(null);

  // The user selected in the UI to show details for
  self.selectedConsumerSessionId = ko.observable(null);
  // The queue the selected user came from
  self.selectedConsumerQueueId = ko.observable(null);

  self.selectConsumer = self._selectConsumer.bind(this);
  self.deselectConsumer = self._deselectConsumer.bind(this);

  // The location ids the user selected to manage
  self.selectedLocationIds = ko.observableArray([]);
  // Ids of the queues selected in the sidebar
  self.selectedQueueIds = ko.observableArray([]);
  // Id of the currently servicing transaction
  self.servingTransactionIds = ko.observableArray([]);
  // Whether the add consumer interface is displayed
  self.showAddConsumer = ko.observable(false);
  // Whether the barcode scanner error should be presented
  self.showBarcodeError = ko.observable(false);
  // Whether to display the barcode scanning interface
  self.showBarcodeScanner = ko.observable(false);
  // Whether to show the begin service interface
  self.showBeginService = ko.observable(false);
  // Whether to show the check in serviced dialog
  self.showCheckInServiced = ko.observable(false);
  // Whether the consumer detail panel should be presented
  self.showDetail = ko.observable(false);
  // Controls whether the error modal is shown
  self.showError = ko.observable(false);
  // Whether the external resources panel should be presented
  self.showExternalResources = ko.observable(false);
  // Whether the external resources panel should be presented
  self.showForecastOverride = ko.observable(false);
  // Whether to present the user information as the list view
  self.showListView = ko.observable(false);
  // Controls whether the make eligible modal is shown
  self.showMakeEligible = ko.observable(false);
  // Holds on to the spot to check in for successor queues
  self.preCheckSpot = ko.observable(null);
  // Whether to display the search interface
  self.showSearch = ko.observable(false);
  // Whether the service results UI should be presented to the user
  self.showServiceResults = ko.observable(false);
  // Whether to shot the settings panel
  self.showSettings = ko.observable(false);
  // Whether to show the user menu
  self.showUserMenu = ko.observable(false);
  // Token reasons a SpotModel might be skipped
  self.skippedReasons = [
    'AppointmentWithOtherEmployee',
    'PartySizeOutOfRange',
    'BusyUnticketable',
    'AppointmentStartInFuture',
    'CustomPropNotMatch',
    'CustomPropOtherEmployeeMatch',
    'LanguageOtherEmployeeServe',
    'TransactionTypeOtherEmployeeServe'
  ];
  // Holds the predecessor Queue
  self.successor = ko.observable(null);
  // Holds the user's language preference
  self.userLang = ko.observable('en');
  // Object to hold user preferences
  self.userPrefs = ko.computed({
    owner: self,
    read: function () {
      return self.userPreferences.preferences()
    },
    write: function (newPreferences) {
      self.userPreferences.update(newPreferences)
    }
  });
  // Represents the current version, pulled from the package.json
  self.version = ko.deferredComputed(function () {
    return self.readVersion();
  }, self);

  // SHIMS
  self.expiredConsumers = ko.observableArray([]);
  // self.locations					          = ko.observableArray( [] );
  self.queues = ko.observableArray([]);
  self.queueIds = ko.observableArray([]);
  self.selectedLocations = ko.observableArray([]);
  self.summonedConsumers = ko.observableArray([]);

  // Web Service Transaction Objects
  self.activeServiceTransactionsWS = new ActiveServiceTransactionsWS(self);
  self.authInfoWS = new AuthInfoWS(self);
  self.checkStationWS = new CheckStationWS(self);
  self.consumerExternalProfileWS = new ConsumerExternalProfileWS(self);
  self.consumerInfoNotesWS = new ConsumerInfoNotesWS(self);
  self.employeesWS = new EmployeesWS(self);
  self.endServiceTransactionWS = new EndServiceTransactionWS(self);
  self.enterQueueWS = new EnterQueueWS(self);
  self.eventsWS = new EventsWS(self);
  self.heartbeatWS = new HeartbeatWS(self);
  self.locationsWS = new LocationsWS(self);
  self.messagesWS = new MessagesWS(self);
  self.queuesWS = new QueuesWS(self);
  self.serviceTransactionStartWS = new ServiceTransactionStartWS(self);
  self.stationUpdateWS = new StationUpdateWS(self);
  self.updateAppointmentStatusWS = new UpdateAppointmentStatusWS(self);
  self.variancesWS = new VariancesWS(self);
  self.wssidWS = new WssidWS(self);
  self.issueTicketOverrideWS = new IssueTicketOverrideWS(self);

  // Dependent Observables
  self.connectionState = self.dependentObservable('status', self.heartbeatWS);
  self.currentlyServicing = self.dependentObservable('transactions', self.activeServiceTransactionsWS);
  self.queues = self.dependentObservable('queues', self.queuesWS);
  self.queueIds = self.dependentObservable('queueIds', self.queuesWS);
  self.wssid = self.dependentObservable('wssid', self.wssidWS);

  self.doRestoreSelectedQueues = ko.computed(this.computeRestoreSelectedQueues, this, { deferEvaluation: true });

  self.storageKeys = {
    queuesForLocations: 'queuesForLocations',
  };

  self.employeeId = function () {
    return self.employeesWS.employeeId;
  }

  /**
   * Allows for locations to be filtered based on
   *
   * @method allLocationIds
   * @returns {Array}
   */
  self.locations = ko.computed(function () {
    var locs = self.locationsWS.locations();

    locs.sort(function (a, b) {
      if (a.description.toLowerCase() === b.description.toLowerCase()) {
        return 0;
      }
      return (a.description.toLowerCase() < b.description.toLowerCase()) ? -1 : 1;
    });

    return locs;
  });

  /**
   * Compiles a list of all location IDs returned from the API
   *
   * @method allLocationIds
   * @returns {Array}
   */
  self.allLocationIds = ko.computed(function () {
    var locs = self.locations();

    return locs.reduce(function (arr, loc) {
      arr.push(loc.id);
      return arr;
    }, []);
  });


	/**
	 * Provides insight on the global queue states; used for messaging and
   * decision forking
   *
   * @method allQueuesActive
   * @returns {Boolean}
   */
  self.allQueuesActive = ko.computed(function () {
    var bAllActive = true;
    var queues = self.queues();

    queues.forEach(function (q) {
      if (q.state() !== 'ACTIVE') {
        bAllActive = false;
      }
    });

    return bAllActive;
  });


  /**
   * Message to present regarding the button action above all queues to
   * toggle them all on or off
   *
   * @method allQueueToggleMessage
   * @returns {String}
   */
  self.allQueueToggleMessage = ko.computed(function () {
    var token = (self.allQueuesActive()) ? 'deactivate' : 'activate';

    return self.messagesWS.get(token + '.all.queues');
  });


  /**
   * Returns a lest of queues that have appointments enabled
   *
   * @method appointmentQueues
   * @returns {Array}
   */
  self.appointmentQueues = ko.computed(function () {
    var queues = self.queues();

    if (queues.length > 0) {
      return queues.filter(function (q) {
        return q.appointmentsEnabled;
      });
    }

    return [];
  });


  /**
   * Begins service for an appointment
   *
   * @method beginService
   * @param {Object} data
   * @param {MouseEvent} evt
   * @returns {Boolean} false
   */
  self.beginService = function (data, evt) {
    if (!evt.target.classList.contains('disabledbtn')) {
      self.serviceTransactionStartWS.appointmentId(data.id);
      self.serviceTransactionStartWS.queueId(data.queueId);
      self.serviceTransactionStartWS.phone(data.consumer.phone);
      self.serviceTransactionStartWS.partySize(data.partySize);

      self.serviceTransactionStartWS.doRequest();

      evt.target.classList.add('disabledbtn');
    }

    return false;
  };


  /**
   * Watch for changes with the currentlyServicing observable. If the
   * consumer detail is shown when this is set to null, then hide the
   * detail.
   *
   * @method currentlyServicing.subscribe
   * @returns none
   */
  self.currentlyServicing.subscribe(function (val) {
    var detailVM = self.consumerDetailVM

    // If the value is null or an empty array OR the detail is being shown
    // AND the detail is of a servicing consumer, hide it.
    if (!self.userPreferences.get("showDetailOnArrival") && ((!val || val.length == 0) || (self.showDetail() && detailVM.detailIsServicing()))) {
      self.hideDetail();
    }
  });


  /**
   * Returns a list of successor Queue Ids the Consumer can next moveConsumere to
   *
   * @method currentlyServicingSuccessors
   * @return {Array}
   */
  self.currentlyServicingSuccessors = ko.computed(function () {
    var q = null;
    var successors = [];
    var trans = null;

    // TODO determine successors for the spot model in question out of the array
    if (self.currentlyServicing().length > 0 && self.endServiceSessionId() != null) {
      trans = self.currentlyServicing().filter(function (t) {
        return t.sessionId === self.endServiceSessionId();
      })

      if (trans.length > 0) {
        q = self.queuesWS.getQueueById(trans[0].queueId);

        if (q && q.successorQueueIds) {
          successors = q.successorQueueIds;
        }
      }
    }

    return successors;
  });


  /**
   * Returns a boolean indicating whether the settings panel should be
   * displayed to the user
   *
   * @method settingsVisible
   * @returns {Boolean}
   */
  self.settingsVisible = ko.computed(function () {
    return self.showSettings() && self.selectedLocationIds().length > 0;
  });


  /**
   * When the selected locations change, get the corresponding queues
   *
   * @method selectedLocationIds.subscribe
   * @param {Mixed} newVal
   * @returns none
   */
  self.selectedLocationIds.subscribe(function (newVal) {
    // Need to load the message bundles with whatever languages are known
    // to the selected locations.
    self.messagesWS.doRequest();
    // Get all the queues for the selected locations
    self.getQueues();

  }, 'change');


  /**
   * Determines is any of the selected locations support this configurations
   *
   * @method allowQueueChangesDuringServicing
   * @return {Boolean}
   */
  self.allowQueueChangesDuringServicing = ko.computed(function () {
    var arr = [];
    var locs = self.selectedLocations();

    if (locs && locs.length > 0) {
      arr = locs.filter(function (loc) {
        return loc.allowQueueChangesDuringServicing == true;
      });

      return arr.length > 0;
    }

    return false;
  });


  /**
   * Begins a service transaction for a consumer
   *
   * @method beginServiceTransaction
   * @param {String} consumerName
   * @param {String} phone
   * @param {String} ticketClassifierDescription
   * @param {Number} queueId
   * @param {Object} spot
   * @returns none
   */
  self.beginServiceTransaction = function (consumerName, phone, ticketClassifierDescription, queueId, spot) {
    var consumerName = (consumerName) ? consumerName.toString() : '';
    var fullName = null;
    var phone = null;
    var privateName = null;
    var privatePhone = null;
    var privatePhoneDigitCount = null;
    var queue = null;

    if (self.recordServiceTransactions() && !self.allowParallelServiceTransactions()) {

      if (spot != null) {
        privateName = spot.privateName;

        if (phone == null) {
          phone = spot.phone && String(spot.phone);
        }
      }

      queue = self.queuesWS.getQueueById(queueId);

      privatePhoneDigitCount = queue.privatePhoneDigitCount;
      privatePhone = self.getPrivateName(phone, privateName, null, false, privatePhoneDigitCount);
      fullName = privatePhone;

      if (consumerName && consumerName.length > 0) {
        fullName = consumerName;

        // append privatePhone to consumerName, but only if phone is available
        if (phone && String(phone).length > 0) {
          fullName += ' - ' + privatePhone;
        }
      }

      if (ticketClassifierDescription && ticketClassifierDescription.length > 0) {
        fullName += ' - ' + ticketClassifierDescription;
      }

      self.checkInServicedVM.openIfNecessary();
    }

    if (self.userPreferences.get("showDetailOnArrival") === true) {
      self.showConsumerServicing(spot);
    }
  };


  /**
   * Describes if any queues at any selected locations support call ahead
   * Note the computedObservable is wrapped inside a closure
   *
   * @method callAheadSupported
   * @param {Boolean} bDeep
   * @returns {Boolean}
   */
  self.callAheadSupported = function (bDeep) {
    return ko.computed(function () {
      var supported = false;
      var queues = self.queues() || [];

      supported = queues.filter(function (q) {
        return q.supportsCallAhead === true;
      }).length > 0;

      if (!supported && queues.length > 0) {
        queues.forEach(function (q) {
          if (q.successorQueueIds.length > 0) {
            supported = (bDeep) ? true : false;
          }
        });
      }

      return supported;
    });
  };

  /**
	 * Arrives the specified Consumer
	 *
   * @param {QueueModel} queue
	 * @param {SpotModel} consumer
	 * @returns false
	 */
  self.redeemTicket = function (queue, consumer) {
    // Make sure the user even has the permission to redeem
    if (self.canSeeSummoned(queue.id)) {
      // Set the parameters required to redeem the consumer ticket
      queue.redeemWS.params = {
        'sessionId': consumer.sessionId,
        'transactionTypeId': consumer.transactionTypeId
      };

      if (!self.allowParallelServiceTransactions()) {
        self.endOtherCurrentServiceTransactions(consumer.sessionId);
      }

      queue.redeemWS.doRequest(function () {
        self.activeServiceTransactionsWS.doRequest();

        // If the showDetailOnArrival flag is not set to true,
        // Hide any detail that may have been shown
        if (self.userPreferences.get("showDetailOnArrival")) {
          self.consumerDetailVM.reset();
          self.selectConsumer(consumer.sessionId, consumer.queueId);
          self.showDetail(true);
          self.consumerDetailVM.show(consumer);
        } else {
          self.hideDetail();
        }
      });

      var successorQueue = self.queuesWS.getQueueById(queue.successorQueueId);

      if (successorQueue && successorQueue.length > 1) {
        successorQueue = successorQueue[0];
      }
      var location = self.locationsWS.getLocationById(queue.locationId);
      if (queue.serviceResults.length < 1 && successorQueue && !location.recordServiceTransactions) {
        var spot = successorQueue.getSpotBySessionId(consumer.sessionId);
        if (spot && spot.callAhead) {
          self.showMakeEligible(true);
          self.preCheckSpot(spot);
          self.successor(successorQueue);
        }
      }
    }
  };


  /**
   * Validates a barcode and looks for a carriage return/newline to initiate
   * the barcode complete action and arrive the consumer
   *
   * @method checkBarcodeInput
   * @param {Mixed} data
   * @param {KeyboardEvent} evt
   * @return {Boolean} true
   */
  self.checkBarcodeInput = function (data, evt) {
    var spot = null;
    var val = self.barcode();
    var ws = null;

    // Hide any preview error message which may have been presented
    self.showBarcodeError(false);

    // Process the barcode value upon return
    if (evt.keyCode == 13) {
      // Reset the barcode value
      self.barcode(null);

      // Finding the spot
      let obj = self.queuesWS.findConsumerByTicket(val);

      // If a spot was found, move it along in the workflow
      if (obj.spot) {
        spot = obj.spot;

        // If the consumer is waiting, summon them
        if (obj.place === 'queued') {
          // Summon the consumer
          ws = new UpdateConsumerInfoWS(self);
          ws.endpoint('/qless/api/v1/employee/queue/' + spot.queueId + '/ticket/override');

          ws.addParam('queueId', spot.queueId);
          ws.addParam('sessionId', spot.sessionId);

          ws.doRequest();
        }
        // If the consumer is already summoned, arrive them
        else if (obj.place === 'summoned') {
          self.redeemTicket(spot.queue(), spot);
        }
        // TO-DO
        // If the consumer has been arrived, end the transaction
        else if (obj.place === 'servicing') {
          self.endService(spot.sessionId);
        }

      }
      // If a spot was not found, report the error
      else {
        self.showBarcodeError(true);
      }
    }

    return true;
  };


  /**
   * Marks a consumer as checked in
   *
   * @method checkIn
   * @param {SpotModel} consumer
   * @return none
   */
  self.checkIn = function (consumer) {
    var endpoint = '/qless/api/v1/employee/location/' + consumer.queue().locationId + '/callAhead';
    var successors = null;
    var ws = new CallAheadWS();

    self.queues().forEach(function (q) {
      var successorIds = null;

      if (!successors) {
        if (q.successorQueueIds.length > 0) {
          successors = q.successorQueueIds;
          endpoint = '/qless/api/v1/employee/queues/' + consumer.queue().id + '/callAhead';
        }
      }
    });

    ws.endpoint(endpoint);
    ws.addParam('sessionId', consumer.sessionId);
    ws.addParam('callAhead', false);
    ws.doRequest();
  };


  /**
   * Handles keyboard events on the body and responds accordingly
   *
   * @method checkKey
   * @param {Object} data
   * @param {KeyboardEvent} evt
   * @returns {Boolean} true
   */
  self.checkKey = function (data, evt) {
    var keyCode = evt.key;

    if (self.locationSelectionVM.isVisible() && keyCode === 'Enter') {
      self.locationSelectionVM.setSelectedLocations();
    }

    return true;
  };


  /**
   * Returns a formatted custom property name
   *
   * @method cleanCustomPropertyName
   * @param {String} label
   * @returns {String}
   */
  self.cleanCustomPropName = function (label) {
    var labelParts = label.split('_');
    labelParts = labelParts.map(function (part) {
      return part.substr(0, 1).toUpperCase() + part.substr(1);
    })

    return labelParts.join(' ');
  };


  /**
   * Removes any location selection information
   *
   * @method clearSelectedLocations
   * @returns none
   */
  self.clearSelectedLocations = function () {
    self.showListView(false);
    self.selectedLocationIds.removeAll();
    self.queueSelectionVM.clearAllSelectedQueues();
  };


  /**
   * Cancels the confirm clear dialogue
   *
   * @method confirmClearCancel
   * @param {*} data
   * @param {MouseEvent} evt
   * @returns {Boolean} true
   */
  self.confirmClearCancel = function (data, evt) {
    self.clearQueue(null);
    self.confirmClearVisible(false);

    return true;
  }


  /**
   * Asks the selected queue to clear all consumers
   *
   * @method confirmClearConfirm
   * @param {*} data
   * @param {MouseEvent} evt
   * @returns {Boolean} true
   */
  self.confirmClearConfirm = function (data, evt) {
    if (self.clearQueue()) {
      var q = self.clearQueue();
      q.clear();
    }

    self.confirmClearCancel();

    return true;
  };


  /**
   * Parses the connection status and responds with the Message string
   *
   * @method connectionStatus
   * @returns {String}
   */
  self.connectionStatus = function () {
    return self.messagesWS.get('connection.' + self.connectionState().toLowerCase());
  };


  /**
   * Message intermediary. The current properties string includes a token
   * which we do not need in CEC. This message string needs to be duplicated
   * without the token.
   *
   * @method currentlyServingMessage
   * @returns {String}
   */
  self.currentlyServingMessage = ko.computed(function () {
    return self.messagesWS.get('currently.serving').replace(' {0}', '');
  });


  /**
   * Determines is any of the selected locations support this configurations
   *
   * @method disableCheckInServicedDialog
   * @return {Boolean}
   */
  self.disableCheckInServicedDialog = ko.computed(function () {
    var arr = [];
    var locs = self.selectedLocations();

    if (locs && locs.length > 0) {
      arr = locs.filter(function (loc) {
        return loc.disableCheckInServicedDialog == true;
      });

      return arr.length > 0;
    }

    return false;
  });


  /**
   * Determines if the user has the antipattern which prevents
   * them from adjusting the forecast
   *
   * @method disallowForecastOverride
   * @param [String|Number|Array] queueIds
   * @returns {Boolean}
   */
  self.disallowForecastOverride = function (queueIds) {
    if (!Array.isArray(queueIds)) {
      queueIds = [queueIds];
    }

    if (self.authInfoWS.antiRoles().indexOf('forecastOverride') > -1) {
      return true;
    }
    else if (queueIds) {
      return queueIds.filter(function (qId) {
        return self.authInfoWS.antiRoles().indexOf('forecastOverride' + qId) > -1;
      }).length > 0;
    }

    return false;
  }


  /**
   * Creates or returns (if already exists) a named observable
   *
   * @method dynamicObservable
   * @param {String} name
   * @param {Mixed} value
   * @returns {Observable | Null}
   */
  self.dynamicObservable = function (name, value) {
    var observable = null;

    // And observable MUST be named
    if (name) {
      // Attempt to pull an existing observable
      observable = self[name];

      // If an observable was not found, initialize a new observable and
      // set it as a member of the view model
      if (!observable) {
        self[name] = new ko.observable();
        observable = self[name];
      }

      // Now that an observable is sure to exist, if a value was
      // passed, assign that to the observable as a value
      if (typeof value !== 'undefined') {
        observable(value);
      }
    }

    // Return the observable or null
    return observable;
  };


  /**
   * KO Event/Binding handler for End Service button. 
   * 
   * @param {*} data 
   * @param {*} event 
   */
  self.handleEndService = function(data, event) {
    // console.trace(data, event, arguments)
    self.endService(data.sessionId);
  }

  /**
   * Ends service for the currently serving Consumer
   *
   * @method endService
   * @param {string} sessionId
   * @param {Boolean} force
   * @param {boolean} ignoreNextQueues when true, the service is ended without triggering the Next Queue prompt
   * @returns none
   */
  self.endService = function (sessionId, ignoreNextQueues) {

    if (!sessionId) {
      // Handle some strange case like ending the first service or all services
      return false;
    }

    // Fetch the Spot from Currently Serving
    var targetTransaction = self.activeServiceTransactionsWS.findTransaction(sessionId)
    if (targetTransaction === undefined) {
      // Session wasn't found in the Spots being served; bail out
      return false;
    }

    var transactionQueue = (targetTransaction.queueId) 
      ? self.queuesWS.getQueueById(targetTransaction.queueId)
      : null;

    var transactionSpot = targetTransaction.spot;

    // When a Service Transaction is started via the 'Begin Service' button/feature
    // the transaction will not have a Spot.
    //
    // Transactions started this way are not eligible for the Next Queue feature.
    // This might be use case for a policy fn/class check a la domain models.
    var startedFromBeginService = (transactionSpot === undefined);

    // select the first successor queue, as that will be next successor queue in order?
    var successorQueue = (transactionQueue.successorQueueIds.length >= 1)
      ? self.queuesWS.getQueueById(transactionQueue.successorQueueIds[0])
      : "";

    if (transactionSpot && successorQueue) {
      // Gets the UI ready to make the successor eligible to be summoned.
      var successorQueueSpot = successorQueue.getSpotBySessionId(transactionSpot.sessionId);
      if (successorQueueSpot && successorQueueSpot.callAhead) {
        self.preCheckSpot(successorQueueSpot);
        self.successor(successorQueue);
      }
    }

    // check if the selected locations are using recordServiceTransactions
    var recordServiceTransactionsEnabled = window.vm.selectedLocations().some(function (location) {
      return location.recordServiceTransactions;
    });

    // check if the current spot has service results, if not we can show the makeEligible modal
    if (
      recordServiceTransactionsEnabled 
      && self.preCheckSpot() 
      && self.successor() 
      && transactionQueue.serviceResults.length < 1
    ) {
      window.vm.showMakeEligible(true);
    }

    self.endServiceSessionId(transactionSpot.sessionId)

    if (transactionQueue && transactionQueue.canApplyServiceResults()) {
      var serviceResultClose = self.serviceResultVM.detailShow(targetTransaction);
      serviceResultClose.then(function () {
        if (transactionQueue.hasNextQueues() && !ignoreNextQueues && !startedFromBeginService) {
          if (successorQueue) {
            console.warn("Predecessor/Successor Queue Configurations should not be combined with Queue Next Queue configurations. Use either one, not both.");
          }
          self.handleReenterConsumerInNextQueues(transactionSpot, null);
        } 
      })
    }
    else {
      self.endServiceTransaction(
        transactionSpot.queueId,
        targetTransaction.transactionId, 
        false
      );

      if (transactionQueue.hasNextQueues() && !ignoreNextQueues && !startedFromBeginService) {
        if (successorQueue) {
          console.warn("Predecessor/Successor Queue Configurations should not be combined with Queue Next Queue configurations. Use either one, not both.");
        }
        self.handleReenterConsumerInNextQueues(transactionSpot, null);
      } 
    }

    // Refresh transactions
    self.activeServiceTransactionsWS.doRequest();

    return true;
  };

  /**
   * 
   * @param {string} sessionId 
   * @param {boolean} ignoreNextQueues
   */
  self.endOtherCurrentServiceTransactions = function (sessionId, ignoreNextQueues) {

    if (!sessionId) {
      // Handle some strange case like ending the first service or all services
      return false;
    }

    // Filter out all the ones but the session ID
    var otherServiceTransactions = self.currentlyServicing().filter(function (transaction) {
      return transaction.spot.sessionId != sessionId
    })

    otherServiceTransactions.forEach(function (transaction) {
      var queue = self.queuesWS.getQueueById(transaction.spot.queueId)
      var queueId = transaction.spot.queueId
      var transactionId = transaction.transactionId
      var successorQueue = (queue.successorQueueIds.length >= 1)
      ? self.queuesWS.getQueueById(queue.successorQueueIds[0])
      : "";

      self.endServiceSessionId(transaction.spot.sessionId);

      if (queue 
        && queue.serviceResults.length > 0 
        && (queue.transactionTypes.length > 0 || queue.serviceTransactionTypes.length > 0)
      ) {
        var serviceResultClose = self.serviceResultVM.detailShow(transaction);
        serviceResultClose.then(function () {
          if (queue.hasNextQueues() && !ignoreNextQueues)  {
            // We don't check if the Transaction does not have a Spot here,
            // because that only occurs for Begin Service/when Parallel
            // Service Transactions are allowed.
            if (successorQueue) {
              console.warn("Predecessor/Successor Queue Configurations should not be combined with Queue Next Queue configurations. Use either one, not both.");
            }

            // Because this was triggered via the click binding, `force` is actually the KO event data.
            self.handleReenterConsumerInNextQueues(transaction.spot, null);
          } 
        })
      }
      else {
        self.endServiceTransaction(queueId, transactionId, false);

        if (queue.hasNextQueues() && !ignoreNextQueues) {
          if (successorQueue) {
            console.warn("Predecessor/Successor Queue Configurations should not be combined with Queue Next Queue configurations. Use either one, not both.");
          }
          self.handleReenterConsumerInNextQueues(transaction.spot, null);
        } 
      }
    })

    self.activeServiceTransactionsWS.doRequest();
  }


  /**
   * DESCRIPTION
   *
   * @method endServiceTransaction
   * @param {Number} queueId
   * @param {Number} transactionId
   * @param {Boolean} doCheckInServicedCheck
   * @param {Function} serviceDetailOKCallback
   * @returns none
   */
  self.endServiceTransaction = function (queueId, transactionId, doCheckInServicedCheck, serviceDetailOKCallback) {
    var transaction = null;
    var queue = null;
    var serviceCheck = false;
    var trans = null;
    var usesServiceResults = false;
    var usesTransactionTypes = false;

    if (queueId && transactionId) {
      trans = self.currentlyServicing().filter(function (t) {
        return t.transactionId == transactionId;
      });

      if (trans.length > 0) {
        transaction = trans[0];
      }

      queue = self.queuesWS.getQueueById(queueId);

      if (queue && transaction) {
        usesServiceResults = false; //( queue.serviceResults.length > 0 );
        usesTransactionTypes = (queue.transactionTypes.length > 0 || queue.serviceTransactionType != null);

        // If the queue uses service results and transaction types and the service result dialogue isn't open, show the
        // service results dialogue
        if (usesServiceResults && usesTransactionTypes && !self.showServiceResults()) {
          self.serviceResultVM.detailShow(transaction, doCheckInServicedCheck, serviceDetailOKCallback);

          if (!doCheckInServicedCheck) {
            trans = self.currentlyServicing().filter(function (t) {
              return t.transactionId != transactionId;
            })

            self.currentlyServicing(trans);
          }
          // 	serviceDetail.open();
        }
        // Otherwise, simply end the service transaction immediately.
        else {
          self.endServiceTransactionWS.clearParams();
          self.endServiceTransactionWS.addParam('transactionId', transactionId);

          if (doCheckInServicedCheck) {
            if (self.showBarcodeScanner() == true) {
              serviceCheck = true;

              self.checkInServicedVM.sessionId(self.currentlyServicing().spot.sessionId);
              self.checkInServicedVM.queueIds(self.currentlyServicing().spot.queue().successorQueueIds);
              self.checkInServicedVM.locationId(self.currentlyServicing().spot.queue().locationId);

              self.checkInServicedVM.yes();
            }
            else {
              serviceCheck = self.checkInServicedVM.openIfNecessary();
            }
          }

          if (!serviceCheck) {
            self.doEndServiceTransactionWS();
          }
        }

      }
    }
  };


  /**
   * Ends the service transaction
   *
   * @method doEndServiceTransactionWS
   * @param {Function} callback 
   * @returns none
   */
  self.doEndServiceTransactionWS = function (callback) {
    var consumer = null;
    var q = null;

    if (self.endServiceTransactionWS.params.transactionId) {
      consumer = self.currentlyServicing().find(function (trans) {
        return trans.transactionId == self.endServiceTransactionWS.params.transactionId;
      })

      if (consumer) {
        q = self.queuesWS.getQueueById(consumer.queueId);
        //nextQueueIds = q.nextQueueIds,
        //queueId = consumer.queueId;

        // spot check disallows consumers served using the Begin Service button from being eligible for the next queue
        // Don't display the nextQueueDialog again, if we already displayed in;
        // This can occur if you requeue a spot that has next queues configured
        // if ( !nextQueueDialog.alreadyDisplayed && consumer != null && nextQueueIds != null ) {
        // 	var consumerInfo = util.getConsumerInfoFromServiceTransaction(endServiceTransactionWS.transactionId);
        // 	nextQueueDialog.doOpen(consumerInfo[0], nextQueueIds, new lz.Delegate(endServiceTransactionWS, "doRequest"),
        // 		consumerInfo[1], consumerInfo[2], consumerInfo[3], consumerInfo[4], consumerInfo[5], consumerInfo[6], consumerInfo[7], false, false);
        // } else {
        self.endServiceTransactionWS.doRequest(function endServiceTransactionCallback() {
          self.activeServiceTransactionsWS.doRequest();
          if (typeof callback === 'function') {
            callback();
          }
        });
        // }
      }
    }

  };


  /**
   * Formats a wait time into a string
   *
   * @method formatWaitTime
   * @param {Number} dur
   * @param {String} units
   * @returns {String}
   */
  self.formatWaitTime = function (dur, units) {
    var hours = 0;
    var min = 0;
    var sTime = '';
    var waitTimeMillis = 0;

    // If either parameter was passed as null, there will
    // not be enough information to return a correct string
    // so simply return a blank string
    if (!dur || !units) {
      return sTime;
    }

    // Convert duration to milliseconds, based on the units
    switch (units) {
      case 'ns':
        waitTimeMillis = dur / 1000;
        break;

      case 'ms':
        waitTimeMillis = dur * 1;
        break;

      case 'sec':
        waitTimeMillis = dur * 1000;
        break;

      case 'min':
        waitTimeMillis = dur * 1000 * 60;
        break;

      case 'hrs':
        waitTimeMillis = dur * 1000 * 60 * 60;
        break;

      case 'days':
        waitTimeMillis = dur * 1000 * 10 * 60 * 24;
        break;
    }

    // As long as milliseconds are greater than zero, determine how
    // many hours and minutes are represented by the duration, and
    // return those concatenated as a string.
    if (waitTimeMillis > 0) {
      // Get the number of hours
      hours = Math.floor(waitTimeMillis / 1000 / 60 / 60);

      // Subtract the corresponding milliseconds
      waitTimeMillis -= hours * 1000 * 60 * 60;

      // Figure out how many minutes based on what's left.
      min = Math.floor(waitTimeMillis / 1000 / 60);

      // If there are any hours, start the string with that
      if (hours > 0) {
        sTime = hours + ' ' + self.messagesWS.get('hour.abbreviated');
        sTime += ', ';
      }

      // Set the string with minutes values
      sTime += min + ' ' + self.messagesWS.get('minute.abbreviated');
    }

    // Return the string
    return sTime;
  };


  /**
   * Calculates the name to display for a consumer
   *
   * @method getPrivateName
   * @param {String} normaliseNumber a phone number only consisting of digits
   * @param {String} privateName
   * @param {String} receiptNumber
   * @param {Boolean} allowEmptyPhone
   * @param {Number} privatePhoneDigitCount
   * @returns {String}
   */
  self.getPrivateName = function (normalisedNumber, privateName, allowEmptyPhone, privatePhoneDigitCount) {
    var mask = self.messagesWS.get('phone.mask');
    var maskedPhone = DisplayPhone.maskPhone(mask, normalisedNumber, false);
    return DisplayPhone.privateNameOrMaskedPrivateName(maskedPhone, privateName, { allowEmptyPhone, privatePhoneDigitCount })
  };

  /**
   * Retrieve a list of queues based on the selected location(s) id
   *
   * @method getQueues
   * @returns none
   */
  self.getQueues = function () {

    self.queuesWS._reset();

    if (self.selectedLocationIds().length > 0) {
      self.queuesWS.doRequest(function () {
        self.activeServiceTransactionsWS.doRequest();

        if (self.userPreferences.get('listView ')=== true) {
          self.toggleListView(null, true);
          // When we update the selected locations we do a fresh pull to the server
          // to update the list view. We cannot use the listVM.update function here
          // as the list view has not yet come into view.
          self.listVM.listViewAppointmentsWS.doRequest();
          self.listVM.listViewRecentArrivalsWS.doRequest();
        }
      });
    }
  };

  /**
   * Returns the validated locale from the query parameter to ensure
   * that we are not sending any random value to the server
   *
   * @method validatedLocaleQueryParam
   * @returns {String || Null}
   */

  self.validatedLocaleQueryParam = function (locale) {
    var regexMatch = new RegExp(/^[a-z.-_]+$/ig).exec(locale);
    return locale && locale.length >= 2 && regexMatch ? locale : null;
  }


  /**
   * Derives the user's browser language
   * If a sticky was found, that will be used, else the browser's default
   * language will be used
   *
   * @method getUserLanguage
   * @returns {String}
   */
  self.getUserLanguage = function () {
    return self.validatedLocaleQueryParam(self.getQueryParam('locale')) || self.userPreferences.get('language') || navigator.language || navigator.userLanguage || 'en';
  };



  /**
   * Returns a collection of language tokens for all selected locations
   *
   * @method availableLanguages
   * @returns {Array}
   */
  self.availableLanguages = ko.computed(function () {
    var bndl = self.messagesWS.bundle();
    var langs = [];
    var locIds = self.selectedLocationIds(); // Computed Observable Hook
    var locs = self.selectedLocations();
    var userLang = self.getUserLanguage();

    if (bndl && locs && locs.length > 0) {
      langs = locs.reduce(function (arr, loc) {
        if (loc.language) {
          loc.language.forEach(function (lang) {
            if (!arr.includes(lang)) {
              arr.push(lang);
            }
          });
        }

        return arr;
      }, []);
    }

    // set the default bundle once the languages are loaded
    self.messagesWS.setLocale(userLang);

    return langs || [];
  });


	/**
	 * Grab the current version from the data injected into the HTML template
   * in the Grunt build
	 *
	 * @method readVersion
	 * @returns none
	 */
  self.readVersion = function () {
    return document.getElementById('pkg-version').dataset.version
  };


  /**
   * Catch for keypresses
   *
   * @method handleKeyDown
   * @param {*} evt
   * @return {Boolean} true
   */
  self.handleKeyDown = function (evt) {
    switch (evt.keyCode) {
      case 13: // Enter/return key
        if (self.showAddConsumer() && self.addConsumerVM.addButtonEnabled()) {
          self.addConsumerVM.addCustomerToQueue();
        }
        break;
    }

    return true;
  };

  window.document.addEventListener('keydown', self.handleKeyDown);


  /**
   * Responds to clicks within the User menu
   *
   * @method handleUserMenuAction
   * @param {Object} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.handleUserMenuAction = function (data, evt) {
    var id = evt.target.getAttribute('id');
    var external = evt.target.getAttribute('data-external') && evt.target.getAttribute('data-external') == 'true';
    var loc = null;

    self.userMenuHide();

    switch (id) {
      case 'emplMenuLogout':
        document.location.replace('/login/?logout=true');
        break;

      case 'emplMenuChangeLoc':
        self.deselectConsumer();
        self.hideAllDialogues();
        self.clearSelectedLocations();
        break;

      case 'emplMenuCalendar':
        loc = '/calendar';
        break;

      case 'emplMenuConfig':
        loc = '/qlessConfig';
        break;

      case 'emplMenuDashboard':
        loc = '/dashboard';
        break;

      case 'emplMenuReporting':
        loc = '/qless/reports/?filteredLocations=' + self.selectedLocationIds().join(',');
        break;

      case 'emplMenuSettings':
        self.settingsShow();
        break;

      case 'emplMenuChangePass':
        loc = '/qless/password/?target=/cec';
        break;

      case 'emplMenuHelp':
        break;
    }

    if (loc) {
      if (external) {
        window.open(loc);
      }
      else {
        document.location.href = loc;
      }
    }
  };


  /**
   * Proxy for the AuthInfoWS service method of the same name
   *
   * @method hasAntiRole
   * @param {String} sRole
   * @returns {Boolean}
   */
  self.hasAntiRole = function (sRole) {
    return self.authInfoWS.hasAntiRole(sRole);
  };


  /**
   * Proxy for the AuthInfoWS service method of the same name
   *
   * @method hasRole
   * @param {String} sRole
   * @returns {Boolean}
   */
  self.hasRole = function (sRole) {
    return self.authInfoWS.hasRole(sRole);
  };


  /**
   * This method hides any exposed dialogues. Not a huge fan of this approach
   * as each 'show' method must be responsible or invoking this method and
   * each dialogue must be registered with this method in order for it to
   * work correctly
   *
   * @method hideAllDialogues
   * @returns none
   */
  self.hideAllDialogues = function () {
    self.showAddConsumer(false);
    self.showBeginService(false);
    self.showDetail(false);
    self.showError(false);
    self.showSearch(false);
    self.showSettings(false);
    self.showUserMenu(false);
    self.showExternalResources(false);
    self.showForecastOverride(false);

    // self.releaseNotesVM.hide()

    self.errorTitle(self.messagesWS.get('error'));
    self.errorMessage(null);
  };


  /**
   * Hides the consumer detail panel
   *
   * @method hideDetail
   * @returns none
   */
  self.hideDetail = function () {
    // Hide the UI by setting the flag used to render CSS classes
    self.showDetail(false);
    self.deselectConsumer();

    // Reset the detail view model
    try {
      self.consumerDetailVM.reset();
    }
    catch (e) {
      window.Sentry && window.Sentry.captureException(e);
    }
  };

  /**
   * Crafts the message for the Make Eligible modal
   *
   * @method makeEligibleMessage
   * @returns {String}
   */
  self.makeEligibleMessage = ko.computed(function () {
    if (self.preCheckSpot() && self.successor()) {
      return self.preCheckSpot().privateName() + ' is also in the ' + self.successor().description + ' queue. Would you like to make them eligible to be summoned?';
    }
  });

  /**
   * Removes the error modal dialogue from view
   *
   * @method hideMakeEligible
   * @returns none
   */
  self.hideMakeEligible = function () {
    self.preCheckSpot(null);
    self.successor(null);
    self.showMakeEligible(false);
  }

  /**
   * Sets up the customer to be Eligible to be summoned
   *
   * @method makeEligible
   * @params {spot} spot
   * @returns none
   */
  self.makeEligible = function (spot) {
    self.checkIn(self.preCheckSpot());
    self.successor(null);
    self.preCheckSpot(null);
    self.showMakeEligible(false);
  }

  /**
   * Removes the error modal dialogue from view
   *
   * @method hideError
   * @returns none
   */
  self.hideError = function () {
    self.showError(false);
    self.errorTitle(self.messagesWS.get('error'));
    self.errorMessage(null);
  }


  /**
   * Determines is any of the selected locations support this configurations
   *
   * @method hideReenterButtonInArrivedList
   * @return {Boolean}
   */
  self.hideReenterButtonInArrivedList = ko.computed(function () {
    var arr = [];
    var locs = self.selectedLocations();

    if (locs && locs.length > 0) {
      arr = locs.filter(function (loc) {
        return loc.hideReenterButtonInArrivedList == true;
      });

      return arr.length > 0;
    }

    return false;
  });


  /**
   * Object initialization
   *
   * @method init
   * @returns none
   */
  self.init = function () {
    // If auth cookies are present in the browser, go ahead and load the experience
    if (self.isAuthenticated()) {
      self.loadUserPrefs();
      // Grab the user's language, since this will be required in the MessagesWS
      self.userLang(self.getUserLanguage());

      // Start the Event Connection when we have acquired Queue Data
      self.selectedQueues.extend({subscribeOnce: function () {
        // Poll the Linebuster API for Events
        self.eventListener.poll();
        self.queueWatcher.beginWatch();
      }})

      // Grab a fresh WSSID
      self.wssidWS.doRequest();

      // Request the authorization information for the logged in user
      self.authInfoWS.doRequest(function () {
        self.employeesWS.doRequest(self.loadCss);

        self.locationsWS.doRequest(function () {
          document.getElementById('splash').parentElement.removeChild(document.getElementById('splash'));
          // Once the location IDs are known, the messages can be loaded
          self.messagesWS.doRequest(function () {
            // Once the messages have been loaded, look for any feature toggles
            self.loadFeatureToggles();

            if (self.featureToggles().inactiveTimeout) {
              var timeout = parseInt(self.featureToggles().inactiveTimeout, 10);
              if (timeout && timeout > 0) {
                if (self.isDebugMode()) {
                  console.log("Inactive Timeout configured for " + timeout + " minutes.")
                }
                self.idleWatcher = new IdleWatcher(timeout);
                self.idleWatcher.start(function (threshold) {
                  if (threshold >= 1) {
                    document.location.replace('/login/?logout=true&reason=inactive');
                  }
                })
              }
            }
          });
        });

        self.readStickies();
      });

      if (self.userLang() === 'ar') {
        self.isRTL(true);
      }

      // Check whether to show release notes
      self.releaseNotesVM.init();
      // Start polling the service for updated information, every minute
      window.setInterval(self.poll, 60 * 1000);
      // Start the service to check for the connection status to Linebuster
      self.heartbeatWS.start();

    }
    // Otherwise, send the user to the login page
    else {
      document.location.href = '/cec/logout';
    }
  };


  /**
   * Initializes an audio player to play the doorbell sound
   *
   * @method initAudio
   * @returns none
   */
  self.initAudio = function () {
    // Grab the user preference first
    var selectedSound = self.userPreferences.get("notificationSound");
    // If there was a user preference sound, store that in the
    // notificationSound member, else use the default
    var sound = selectedSound || self.notificationSounds()[0];
    self.notificationSound(sound);
    // Initialize the new audio player with the path to the sound
    self.doorbell = new Audio(sound.path);
  };


  /**
   * Retrieves authentication cookies
   *
   * @method isAuthenticated
   * @returns {Boolean}
   */
  self.isAuthenticated = function () {
    var bFoundAuthCookie = false;
    var cookies = document.cookie.split(';');

    if (cookies.length > 0) {
      if (self.store.get('au') != null) {
        bFoundAuthCookie = true;
      }
      else {
        cookies.forEach(function (cookie) {
          var parts = cookie.trim().split('=');

          if (parts[0].indexOf('au__') > -1) {
            bFoundAuthCookie = true;
          }
        });
      }

    }

    // If there was no auth cookies found, return false
    return bFoundAuthCookie;
  };


  /**
   * Determines if the user has permissions to access reports
   * Updates when roles become available/change
   *
   * @method isConfigViewer
   * @returns {Boolean}
   */
  self.isConfigViewer = ko.computed(function () {
    var roles = self.authInfoWS.roles();

    return self.hasRole('merchConfigAdmin') || self.hasRole('merchConfigAccountsAdmin') || self.hasRole('locConfigAdmin') || self.hasRole('locConfigAccountsAdmin');
  });


  /**
   * Determines if a numeric button was pushed
   *
   * @method isNumericInput
   * @param {KeyboardEvent} evt
   * @returns {Boolean}
   */
  self.isNumericInput = function (evt) {
    var code = evt && evt.keyCode;
    var shiftDown = evt && evt.shiftKey;
    var ctrlDown = evt && evt.ctrlKey;
    return code && !(shiftDown || ctrlDown) && ((code >= 48 && code <= 57) || (code >= 96 && code <= 105));
  }


  /**
   * Determines if the user has permissions to access reports
   * Updates when roles become available/change
   *
   * @method isReportViewer
   * @returns {Boolean}
   */
  self.isReportViewer = ko.computed(function () {
    var roles = self.authInfoWS.roles();

    return self.hasRole('reportViewer');
  });


  /**
   * Attempts to load custom CSS from the ThemeManager API
   *
   * @method loadCss
   * @returns none
   */
  self.loadCss = function () {
    window.document.querySelector('#merchantstyle').setAttribute('href', '/themeManager/api/v1/css/merchant/' + self.locations()[0].merchantId + '/qm/blue');
    window.document.querySelector('#employeestyle').setAttribute('href', '/themeManager/api/v1/css/queuemanager/employee/' + self.employeesWS.employeeId);
  }


  /**
   * Parses message bundle tokens looking for messages formatted like FT*
   *
   * @method loadFeatureToggles
   * @return none
   */
  self.loadFeatureToggles = function () {
    var obj = {};
    var tokens = self.messagesWS.bundles[0].m;

    if (tokens) {
      tokens.forEach(function (token) {
        // Feature toggle messages will have the prefix 'FT'
        if (token.n.indexOf('FT') === 0) {
          obj[token.n.replace(/^FT/, '')] = token.text;
        }
      });
    }

    self.featureToggles(obj);
  };

  /**
   * Retrieves user preferences from LocalStorage
   *
   * @method loadUserPrefs
   * @returns none
   */
  self.loadUserPrefs = function () {
    this.userPreferences.load();

    self.userPrefs(this.userPreferences.preferences());

    self.userPrefs.subscribe(function (newPreferences) {
      self.userPreferences.update(newPreferences)
      self.userPreferences.store();
    });

    self.initAudio();
  };


  /**
   * Takes a string or number and returns a version of the number masked
   * with the phone.mask pattern, or the original number if no mask is
   * specified.
   *
   * @method maskPhone
   * @param {String} number - Number to apply the phone.mask to.
   * @param {boolean} del a flag for ?? (related to whitespace characters)
   * @param {string} mask input mask string for phone number 
   * @returns
   */
  self.maskPhone = function (number, del, mask) {
    mask = (!mask) ? self.messagesWS.get("phone.mask") : mask;
    return DisplayPhone.maskPhone(mask, number, del)
  };

  /**
   * Method to manipulate the DOM elements for presentational consistency :(
   *
   * @method matchQueueTitleHeight
   * @return none
   */
  self.matchQueueTitleHeight = function () {
    var iHeight = 0;
    var minHeight = 999;
    var titles = [].slice.call(document.getElementsByClassName('queue-title'));

    titles.forEach(function (t) {
      minHeight = Math.min(Number(t.clientHeight), minHeight);
      t.style.height = 'auto';
    });


    if (titles.length > 1) {
      titles.forEach(function (t) {
        iHeight = Math.max(iHeight, t.offsetHeight);
      })

      iHeight = Math.max(minHeight, iHeight);

      titles.forEach(function (t) {
        t.style.height = iHeight + 'px';
      })
    }
  };

  /**
   * Prepares the addConsumerViewModel to move the consumer into a different queue.
   *
   * @method moveConsumer
   * @returns none
   */
  self.moveConsumer = function (consumer) {
    self.addConsumerVM.moveConsumer(consumer);
    self.showAddConsumer(true);
  }

  /**
   * Prepares the addConsumerViewModel to reenter the consumer into a queue.
   *
   * @method reenterConsumer
   * @returns none
   */
  self.reenterConsumer = function (consumer) {
    self.addConsumerVM.reenterConsumer(consumer);
  }

  self.handleReenterConsumerInNextQueues = function (data, event) {
    // TODO: Change to regular message
    var isAutomaticEnterEnabled = self.messagesWS.get("nextQueue.automaticEnter") === "true";
    var queue = self.queuesWS.getQueueById(data.queueId)

    if (!queue) {
      return;
    }

    var defaultCountryCode = queue.defaultPhoneCountryCode();
    var mustRemoveCountryCode = ( (defaultCountryCode !== null) && (data.spot.countryCode !== null) );

    // If the phone number is prefixed by the country code, we remove it
    // We also apply the mask so the form detects it as valid
    var phoneNumber = (mustRemoveCountryCode) ?
      DisplayPhone.removeCountryCodeAndApplyMask(data.phone, data.spot.countryCode, self.messagesWS.get("phone.mask")) :
      data.phone;

    var consumer = {
      name: data.merchantInfoName,
      phone: phoneNumber,
      notes: (data.notes) ? data.notes : null,
      sessionId: data.sessionId,
      customProps: data.customProps,
      locale: data.locale,
      firstName: data.firstName,
      lastName: data.lastName
    }

    var onlyOneNextQueue = queue.nextQueueIds.length == 1;

    if (isAutomaticEnterEnabled && onlyOneNextQueue) {
      var nextQueueId = queue.nextQueueIds[0];
      var nextQueue = self.queuesWS.getQueueById(nextQueueId)
      /**
       * @type {Array<object>}
       */
      var nextQueueTransactionTypes = nextQueue.transactionTypes 
      var noTransactionTypes = !nextQueueTransactionTypes || nextQueueTransactionTypes.length == 0;
      var nextQueueHasOneTransactionType =  nextQueueTransactionTypes && nextQueueTransactionTypes.length == 1
      var nextQueueHasSelectedTransactionType = nextQueueTransactionTypes 
        && data.transactionTypeId
        && (nextQueueTransactionTypes.filter(t => Boolean(t)).map(
          function (t) { return t.id }
        ).indexOf(data.transactionTypeId) !== -1)

      if (noTransactionTypes) {
        // TODO: Automatic Reenter
        self.enterQueueWS.enterConsumer(consumer, nextQueueId);
      } else if (nextQueueHasOneTransactionType) {
        consumer.transactionId = data.transactionTypeId
        self.enterQueueWS.enterConsumer(consumer, nextQueueId);
      } else if (nextQueueHasSelectedTransactionType) {
        consumer.transactionId = data.transactionTypeId
        self.enterQueueWS.enterConsumer(consumer, nextQueueId);
      } else {
        self.addConsumerVM.reenterConsumerInNextQueues(consumer, queue.nextQueueIds);
        self.showAddConsumer(true);
      }

    } else {
      self.addConsumerVM.reenterConsumerInNextQueues(consumer, queue.nextQueueIds);
      self.showAddConsumer(true);
    }
  }

  /**
   * Returns a list of queues the consumer can be moved to.
   *
   * Excludes queues which:
   * - Are appointment only
   * - The current Queue
   * - Already have a Spot for the selected Consumer
   *
   * @method moveableQueues
   * @returns {Array}
   */
  self.moveableQueues = ko.computed(function () {
    var queues = [];

    if (self.selectedConsumerSessionId()) {
      var currentQueueId = self.selectedConsumerQueueId();
      var currentSessionId = self.selectedConsumerSessionId();

      queues = self.queues().filter(function (q) {
        return (
          !q.appointmentsOnly &&
          q.id !== currentQueueId &&
          !q
            .spots()
            .map(function (s) {
              return s.sessionId;
            })
            .includes(currentSessionId)
        );
      });
    }
    return queues;
  });


  /**
   * Plays a doorbell sound alerting the employee that the application
   * requires their attention
	 *
	 * @method playDoorbell
	 * @return none
	 */
  self.playDoorbell = function () {
    // Stop the doorbell sound if it is playing
    self.doorbell.pause();
    // Rewind the playhead to the beginning
    self.doorbell.currentTime = 0;
    // Play the sound
    self.doorbell.play();
  };

  /**
   * Plays a doorbell sound if the Queue is currently selected by the
   * employee.
   *
   * @param queueId integer the ID of the queue that rang the doorbell.
   */
  self.playDoorbellForQueue = function (queueId) {
    if (self.queueSelectionVM.selectedQueueIds().indexOf(queueId) !== -1) {
      self.playDoorbell();
    }
  }


  /**
   * Interrogates the server for updated consumer wait variances and
   * forecast wait times
   *
   * @method poll
   * @returns none
   */
  self.poll = function () {
    // Call the variances API and then ask each queue to update their
    // own variances
    self.variancesWS.doRequest(function () {
      self.selectedQueues().forEach(function (q) {
        q.updateVariances();
        q.getNextWaitForecast();
      });
    });

    //self.allNextForecastWS.doRequest();
  };

  /**
   * Populates the add consumer model with data from the currently servicing consumer
   *
   * @param {object} data  an object representing a service transaction
   * @method handleRequeueConsumer
   * @returns none
  */
  self.handleRequeueConsumer = function (data, event) {

    function reenterConsumerCallback() {

      var filter = (data.phone) ?
        function(spot) {
          return (spot.phone === data.phone);
        } :
        function(spot) {
          return (spot.sessionId === data.sessionId);
        }

      var currentTransaction = self.activeServiceTransactionsWS.transactions().find(filter);

      var defaultCountryCode = self.queuesWS.getQueueById(data.queueId).defaultPhoneCountryCode()
      var mustRemoveCountryCode = ( (defaultCountryCode !== null) && (data.spot.countryCode !== null) );

      // If the phone number is prefixed by the country code, we remove it
      // We also apply the mask so the form detects it as valid
      var phoneNumber = (mustRemoveCountryCode) ?
        DisplayPhone.removeCountryCodeAndApplyMask(data.phone, data.spot.countryCode, self.messagesWS.get("phone.mask")) :
        data.phone;
      
      var consumer = {
        name: data.name,
        phone: phoneNumber,
        notes: (currentTransaction.notes) ? currentTransaction.notes : null,
        sessionId: data.sessionId,
        uuid: (data.spot.uuid) ? data.spot.uuid : null,
        receiptNumber: (data.spot.receiptNumber) ? data.spot.receiptNumber : null,
        customProps: (data.spot) ? data.spot.customProps : null,
        locale: (data.spot) ? data.spot.locale || null : null,
        firstName: data.spot.firstName,
        lastName: data.spot.lastName
      }

      self.reenterConsumer(consumer);
    }
  
    // Get the latest consumer information notes from the server
    self.activeServiceTransactionsWS.doRequest(reenterConsumerCallback);
  
    // We only want to preselect the queues when there is only 1 queue.
    if(self.queues().length === 1) {
      self.addConsumerVM.setSelectedQueues([data.queueId]);
    }

    self.showAddConsumer(true);
  }

  /**
   * Shows the user the clear confirmation dialogue
   *
   * @method promptClearAll
   * @param {*} data
   * @param {MouseEvent} evt
   * @returns {Boolean} true
   */
  self.promptClearAll = function (data, evt) {
    var id;

    // Make sure the data passed is a QueueModel object
    if (data && data instanceof QueueModel) {
      // If there was an ID associated with the QueueModel
      // store that QueueModel so which know one to clear
      // once the user has confirmed the action
      self.clearQueue(data);
      // Show the confirm clear dialogue
      self.confirmClearVisible(true);
    }

    return true;
  }


  /**
   * Reads temporary cookies in an effort to retain UI presentation
   *
   * @method readStickies
   * @returns none
   */
  self.readStickies = function () {
    var locs = JSON.parse(self.store.get('selectedLocationIds'));
    // Preserve selected locations
    if (locs) {
      if (!Array.isArray(locs)) {
        locs = [locs];
      }

      self.setSelectedLocationIds(locs);
    }
  };

  /**
	 * Removes a consumer from a successor queue
	 *
	 * @method removeSuccessor
	 * @returns none
	 */
  self.removeSuccessor = function () {
    var ws = new UpdateConsumerInfoWS(self);
    ws.endpoint("/qless/api/v1/employee/queue/" + self.successor().id + "/leave");
    ws.addParam("queueId", self.successor().id);
    ws.addParam("sessionId", self.preCheckSpot().sessionId);
    ws.doRequest(self.hideMakeEligible());
  }

  /**
   * Returns a link to the SpotModel in the selected queue that matches
   * the session id in selectedConsumerSessionId()
   *
   * @method selectedConsumer
   * @returns {SpotModel | Null}
   */
  self.selectedConsumer = ko.computed(function () {
    var sessionId = self.selectedConsumerSessionId();
    var queueId = self.selectedConsumerQueueId();

    if (!(sessionId && queueId)) {
      // TODO: It would be great here to have something like `EmptySpot` or `NoSpot`?
      return null;
    }

    // Attempt to find the consumer in the queue. If the consumer is
    //  waiting, expired, or has been summoned they will be found here
    var consumer = self.getSpotBySessionId(sessionId, queueId);

    // If the consumer was not found there, they may be the currently
    // serviced consumer
    if (!consumer) {
      var activeTransaction = self.currentlyServicing().find(function (transaction) {
        return transaction.sessionId === self.selectedConsumerSessionId()
      });

      if (activeTransaction) {
        consumer = activeTransaction.spot;
      }
    }

    try {
      if (consumer) {
        consumer.forecastWS.doRequest();
      }
    }
    catch (e) {
      window.Sentry && window.Sentry.captureException(e);
    }

    return consumer;
  });


  /**
   * Observable to track the currently selected LocationModels
   *
   * @method selectedLocations
   * @returns {Array | Null}
   */
  self.selectedLocations = ko.computed(function () {
    var aLocs = []; // Array of found locations

    // Loop over each selectedLocationId
    self.selectedLocationIds().forEach(function (locId) {
      // This method will return a LocationModel or Null
      var oLoc = self.locationsWS.getLocationById(locId);

      // If a LocationModel was found, add it to the collection
      if (oLoc) {
        aLocs.push(oLoc);
      }
    });

    // If LocationModels were found, return the collection
    // Otherwise return null
    return (aLocs.length > 0) ? aLocs : [];
  });


  /**
   * Permit access to dashboard if there are locations selected
   * and at least one selected location does not have access
   * restricted
   *
   * @method canAccessDashboard
   * @return {Boolean}
   */
  self.canAccessDashboard = ko.computed(function () {
    var locs = self.selectedLocations();

    if (locs && locs.length > 0) {
      var locsWithAccess = locs.filter(function (loc) {
        if (loc.disabledReports && loc.disabledReports.entry) {
          var entries = loc.disabledReports.entry;
          if (!Array.isArray(loc.disabledReports.entry)) {
            entries = [loc.disabledReports.entry];
          }

          var canAccess = true;
          entries.forEach(function (e) {
            if (e.key.toLowerCase() === 'dashboard' && e.value === true) {
              canAccess = false;
            }
          });

          return canAccess;
        }

        return true;
      });

      return locsWithAccess.length > 0;
    }

    return false;
  });


  /**
   * Returns an array of selected location names
   *
   * @method selectedLocationsNames
   * @returns {String}
   */
  self.selectedLocationsNames = ko.computed(function () {
    var aNames = [];
    var locs = self.selectedLocations();

    if (locs) {
      if (locs.length > 3) {
        // TODO - MessageWS this to account for locales
        aNames.push('(Multiple Locations)')
      }
      else {
        locs.forEach(function (loc) {
          aNames.push(loc.description);
        });
      }
    }

    return aNames.join(', ');
  });


  /**
   * Retrieving locations list which has recordServiceTransactions set to true
   *
   * @method getLocationsWithRecordServiceTransactions
   * @returns {Array}
   */
  self.getLocationsWithRecordServiceTransactions = function () {
    var locations = self.selectedLocations() || [];

    return locations.filter(function(location) {
      return location.recordServiceTransactions;
    });
  }

	/**
	 * Determines if at least one selected location has
   * recordServiceTransactions AND allowParallelServiceTransactions
   *
   * @method allowParallelServiceTransactions
   * @returns {Boolean}
   */
  self.allowParallelServiceTransactions = ko.computed(function () {
    var locations = self.selectedLocations();

    if (!locations || locations.length === 0) {
      return false
    }

    return self.getLocationsWithRecordServiceTransactions().some(function(location) {
      return location.allowParallelServiceTransactions;
    });
  });


  /**
   * Determines when the begin service button should be allowed
   *
   * @method allowBeginService
   * @returns {Boolean}
   */
  self.allowBeginService = ko.computed(function () {
    return self.allowParallelServiceTransactions() ||
           (self.getLocationsWithRecordServiceTransactions().length > 0 && self.currentlyServicing().length == 0);
  });


  /**
   * Determines if at least one selected location has
   * recordServiceTransactions
   *
   * @method recordServiceTransactions
   * @returns {Boolean}
   */
  self.recordServiceTransactions = ko.computed(function () {
    var loc = null;
    var locs = self.selectedLocations();

    if (locs && locs.length > 0) {
      loc = locs.find(function (l) {
        return l.recordServiceTransactions;
      });

      return loc && loc.recordServiceTransactions === true;
    }

    return false;
  });


  /**
   * Method to display the search interface to the user
   *
   * @method searchHide
   * @param {Object} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.searchHide = function (data, evt) {
    // Make sure the form is reset each time it is presented to the user
    self.searchVM.reset();
    self.showSearch(false);
  };


  /**
   * Method to display the search interface to the user
   *
   * @method showSearch
   * @param {Object} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.searchShow = function (data, evt) {
    // Make sure the form is reset each time it is presented to the user
    self.searchVM.reset();
    self.hideAllDialogues();
    self.showSearch(true);
    self.searchVM.searchForFocused(true);
  };


  /**
	 * Determines if the user has admin role for
   * all selected locations
   *
   * @method isSelectedLocationsQueueAdmin
   * @returns {Boolean}
   */
  self.isSelectedLocationsQueueAdmin = function () {
    return self.selectedLocations().every(function (location) {
      return self.hasRole('queueAdmin.location.' + location.id);
    });
  }

  /**
   * Returns queue models represented by the selectedQueueIds observable
   *
   * @method selectedQueues
   * @returns {Array}
   */
  self.selectedQueues = ko.computed(function () {
    var detailedQueues = [];
    var queues = self.selectedQueueIds()
    var queueIds = queues

    queueIds.forEach(function (queueId) {
      var queue = self.queuesWS.getQueueById(queueId);

      if (queue) {
        queue.updateAllSpots();
        detailedQueues.push(queue);
      }
    })

    return detailedQueues;
  });

  /**
   * Sets the selected Location Ids for the root view
   *
   * @method setSelectedLocationIds
   * @returns none
   */
  self.setSelectedLocationIds = function (locationIds) {
    self.selectedLocationIds(locationIds);
    self.resetLocations();
  }


  /**
   * Sets of the rest of the UI based on the currently set locations
   *
   * @method resetLocations
   * @returns none
   */
  self.resetLocations = function () {
      self.checkStationWS.reset();

      var ticketClassifierId = self.userPreferences.get('ticketClassifierId');

      if (ticketClassifierId) {
        self.stationUpdateWS.clearParams();
        self.stationUpdateWS.addParam('ticketClassifierId', parseInt(ticketClassifierId));
        self.stationUpdateWS.doRequest();
      }

      self.locationSelectionVM.reset();
  };


  /**
   * Allows for clicks in the UI to set the selected queue id
   *
   * @method setSelectedQueueIds
   * @returns none
   */
  self.setSelectedQueueIds = function (queues) {
    self.selectedQueueIds(queues);

    // ensure that the consumer detail and the add consumer form are not visible
    self.showAddConsumer(false);
    self.showDetail(false);
    self.consumerDetailVM.reset();
  };


  /**
   * Displays the settings panel
   *
   * @method settingsShow
   * @param {Function} fCallback
   * @returns none
   */
  self.settingsShow = function (fCallback) {
    self.showDetail(false);
    self.consumerDetailVM.reset();
    self.settingsVM.handleShow();

    if (fCallback) {
      self.checkStationWS.delegate = fCallback;
    }
  };


  /**
   * Sets user's browser language preference as a sticky
   *
   * @method setUserLanguage
   * @param {String} lang
   * @returns {String}
   */
  self.setUserLanguage = function (lang) {
    if (lang) {
      self.userLang(lang);
      self.messagesWS.setLocale(lang);
    }
  };


  /**
   * Present the Consumer detail panel
   *
   * @method showConsumerDetail
   * @param {SpotModel} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.showConsumerDetail = function (data, evt) {

    if (data &&
        self.selectedConsumer() &&
        self.selectedConsumer().queueId === data.queueId &&
        self.selectedConsumer().sessionId === data.sessionId) {
        return;
    } 

    self.isLoading(false);

    if (evt == null || evt.target.nodeName.toLowerCase() != 'button') {

      var queueId = (evt == null) ? data.queueId : evt.currentTarget.getAttribute('data-queueid');

      // Clear out any existing details the consumerDetailVM had
      self.consumerDetailVM.reset();

      // Indicate that the detail should be presented to the user
      self.selectConsumer(data.sessionId, queueId);
      self.showDetail(true);
      self.consumerDetailVM.show(data);
    }
  };


  /**
   * DESCRIPTION
   *
   * @method showConsumerServicing
   * @param {Mixed} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.showConsumerServicing = function (data, evt) {
    self.isLoading(true);
    self.selectedConsumerNotes(null);

    if (data) {
      var spot = (data instanceof SpotModel) ? data : data.spot;

      if (spot) {
        self.consumerDetailVM.reset();

        // Indicate that the detail should be presented to the user
        self.selectConsumer(spot.sessionId, spot.queueId);
        self.showDetail(true);
        self.consumerDetailVM.show(spot);

        var updateConsumerServicing = function () {
          // Update the consumer information from the server
          self.consumerDetailVM.updateRecentArrivalConsumerInfo();
          self.isLoading(false)
        }
        if (!self.selectedConsumer().merchantConsumerInfoId) {
          // In case if the user started service from the begin service action
          if (!self.selectedConsumer().dateTicketRedeemed) {
            self.consumerDetailVM.updateCurrentlyServicingNotes();
          } else {
            self.listVM.listViewRecentArrivalsWS.doRequest(self.consumerDetailVM.updateRecentArrivalNotes);
          }
        } else {
          self.consumerInfoNotesWS.doRequest(updateConsumerServicing);
        }
      }
    }
  };


  /**
   * Determines if the station selection interface needs to be shown.
   * Inspects whether the location has ticket classifiers and those ticket
   * classifiers are not stored in the metadata (?) and that the
   * ticketClassifier is allowed to be supplied by the employee and the
   * employee does not have a predefined (configured?) ticket classifier
   *
   * @method showClassifierOnSummon
   * @param {QueueModel} oQueue
   * @returns {Boolean}
   */
  self.showClassifierOnSummon = function (oQueue) {
    var loc = self.locationsWS.getLocationById(oQueue.locationId);

    return loc.ticketClassifiers.length > 1 && !loc.ticketClassifiers[1].storeInStationMetadata && (!oQueue.getTicketClassifierFromEmployee || self.employeeWS.ticketClassifier == null);
  };


  /**
   * Determines if location data is required for any of the selected locations
   *
   * @method supportsStationMetaData
   * @returns {Boolean}
   */
  self.supportsStationMetadata = ko.computed(function () {
    var supports = self.selectedLocationIds().reduce(function (currentSupport, id) {
      var location = self.locationsWS.getLocationById(id);
      return location ? (currentSupport || location.supportsStationMetadata()) : false;
    }, false);

    return supports;
  });


  /**
   * Returns a ticket classifier object of the currently selected
   * classifier id
   *
   * @method servingClassifier
   * @returns {Object | Null}
   */
  self.servingClassifier = ko.computed(function () {
    var classifier = null;
    var classifierId = null;

    if (self.supportsStationMetadata() && self.checkStationWS.ticketClassifierId()) {
      classifierId = Number(self.checkStationWS.ticketClassifierId());

      if (self.selectedLocations()) {
        self.selectedLocations().forEach(function (loc) {

          loc.ticketClassifiers.forEach(function (c) {
            if (c.id == classifierId) {
              classifier = c;
            }
          });

        });
      }

      return classifier;
    }

    return null;
  });


  /**
   * Indicates whether the barcode scanning has been enabled
   *
   * @method supportsBarcodeScanning
   * @return {Boolean}
   */
  self.supportsBarcodeScanning = ko.computed(function () {
    var ft = self.featureToggles();
    return ft.supportsBarcodeScanning;
  });


  /**
   * Returns a list of available ticket classifiers. If a queue is
   * (or queues are) selected, it will return ticket classifiers belonging
   * to the locations those queues belong to. Otherwise, it will return
   * ticket classifiers for all selected locations.
   *
   * @method ticketClassifiers
   * @returns {Array}
   */
  self.ticketClassifiers = ko.computed(function () {
    var arr = [];
    var locs = self.selectedLocations();
    var queues = self.selectedQueues();

    function decorateTicketClassifier(loc, classifiers) {
      var newClassifiers = classifiers.slice();

      return newClassifiers.map(function (classifier) {
        var c = Object.assign({}, classifier);
        c.description = loc.description + ' - ' + classifier.description;
        return c;
      })
    }

    // If a queue is (or queues are) selected, it will return ticket
    // classifiers belonging to the locations those queues belong to.
    if (queues && queues.length > 0) {
      queues.forEach(function (q) {
        var l = self.locationsWS.getLocationById(q.locationId);

        if (l) {
          var classifiers = l.ticketClassifiers;
          if (locs.length > 1) {
            classifiers = decorateTicketClassifier(l, l.ticketClassifiers)
          }
          arr = arr.concat(classifiers);
        }
      });
    }
    // Otherwise, it will return ticket classifiers for all selected
    // locations.
    else if (locs && locs.length > 0) {
      locs.forEach(function (l) {
        var classifiers = l.ticketClassifiers;
        if (locs.length > 1) {
          classifiers = decorateTicketClassifier(l, l.ticketClassifiers)
        }
        arr = arr.concat(classifiers);
      });
    }

    return arr.unique();
  });


  /**
   * Displays/Hides the add consumer interface
   *
   * @method toggleAddConsumer
   * @param {Object} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.toggleAddConsumer = function (data, evt) {
    var queueId = null;
    // Grab the intended state of the toggle
    // This is needed because the hideAllDialogue() method will
    // implicitly set the state to false
    var state = !self.showAddConsumer();

    // Hide any existing dialogues, just in case
    self.hideAllDialogues();

    // Set the state to the intended state
    self.showAddConsumer(state);

    // If the new consumer interface is being shown,
    // ensure the addConsumerVM is reset
    if (self.showAddConsumer()) {
      // Get the queue ID of the queue which triggered the event
      queueId = Number(evt.target.getAttribute('data-queueId'));

      if (!queueId) {
        queueId = self.queueSelectionVM.selectedQueueIds()[0];
      }

      // Hide any exposed customer detail
      self.hideDetail();

      // Reset the component to add a new consumer to the line
      self.addConsumerVM.reset(queueId);

      if (self.featureToggles().autoPopulateNotes) {
        self.addConsumerVM.enableAutoPopulateNotes();
      }
    }
  };

  /**
   * Displays/Hides the barcode scanner interface
   *
   * @method toggleBarcodeScanner
   * @param {Object} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.toggleBarcodeScanner = function (data, evt) {
    // Grab the intended state of the toggle
    // This is needed because the hideAllDialogue() method will
    // implicitly set the state to false
    var state = !self.showBarcodeScanner();

    // If barcode scanning is not supported, this method should never
    // have been called. As a failsafe, make sure the state is false.
    state = (self.supportsBarcodeScanning) ? state : false;

    if (typeof data === 'boolean') {
      state = data;
    }

    // always clear the barcode value whether showing or closing
    self.barcode(null);

    // Hide any existing dialogues, just in case
    self.hideAllDialogues();

    // Set the state to the intended state
    self.showBarcodeScanner(state);
  };


  /**
   * Displays/Hides the add consumer interface
   *
   * @method toggleBeginService
   * @param {Object} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.toggleBeginService = function (data, evt) {
    // Grab the intended state of the toggle
    // This is needed because the hideAllDialogue() method will
    // implicitly set the state to false
    var state = !self.showAddConsumer();

    // Hide any existing dialogues, just in case
    self.hideAllDialogues();

    // Reset the begin service form
    self.beginServiceVM.reset();

    if (self.featureToggles().autoPopulateNotes) {
      self.beginServiceVM.enableAutoPopulateNotes();
    }

    // Set the state to the intended state
    self.showBeginService(state);
  };


  /**
   * Displays/Hides the external resources interface
   *
   * @method toggleExternalResources
   * @param {Object} data
   * @param {MouseEvent} evt
   * @return none
   */
  self.toggleExternalResources = function (data, evt) {
    // Flip the flag
    var state = !self.showExternalResources();

    // If the click came from a QueueModel, then make sure state is true
    if (data instanceof QueueModel) {
      state = true;
    }

    // Hide any existing dialogues, just in case
    self.hideAllDialogues();

    // If the state is true, set the VM queue
    if (state) {
      self.externalResourcesVM.queue(data);
    }
    // Otherwise, reset the VM
    else {
      self.externalResourcesVM.reset();
    }

    // Set the state to the intended state
    self.showExternalResources(state);
  };


  /**
   * Displays/Hides the forecast override interface
   *
   * @method toggleForecastOverride
   * @param {Object} data
   * @param {MouseEvent} evt
   * @return none
   */
  self.toggleForecastOverride = function (data, evt) {
    if (self.hasAntiRole('forecastOverride')) {
      return;
    }
    // Flip the flag
    var state = !self.showForecastOverride();

    // If the click came from a QueueModel, then make sure state is true
    if (data instanceof QueueModel) {
      state = true;
    }

    // Hide any existing dialogues, just in case
    self.hideAllDialogues();

    // If the state is true, set the VM queue
    if (state) {
      self.forecastOverrideVM.queue(data);
    }
    // Otherwise, reset the VM
    else {
      self.forecastOverrideVM.reset();
    }

    // Set the state to the intended state
    self.showForecastOverride(state);

  };


  /**
   * Displays/Hides the list view
   *
   * @method toggleListView
   * @param {Object} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.toggleListView = function (data, evt) {
    // Event can be forced as a true boolean
    var flag = (evt === true) ? true : !self.showListView();

    // Flip the flag
    self.showListView(flag);
    self.userPreferences.set('listView', flag);
    self.userPreferences.store();

    // If the list view is to be shown, ask the list view to
    // init or run any other show actions
    if (self.showListView()) {
      self.listVM.show();
    }
    else {
      // Make sure that the Consumer detail panel is hidden
      self.hideDetail();
      // Make sure queue header heights are consistent
      self.matchQueueTitleHeight();
    }
  };


  /**
   * Decrements the forecast wait time by a multiple of the the forecastStep
   *
   * @method unitDecrement
   * @param {Object} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.unitDecrement = function (data, evt) {
    // Variable to determine how far to the next multiple of the step
    var delta = null;
    // The event which triggered the action
    var el = evt.target;
    // The name of the observable the action should update
    var elAction = el.getAttribute('data-action');
    // An optional minimum value
    var min = el.getAttribute('data-min');
    // An optional step parameter indicates how granular each step should be
    var step = (el.getAttribute('data-step') != null) ? Number(el.getAttribute('data-step')) : self.forecastStep;
    // Reference to the observable to update
    var tgt = data[elAction];
    // Calculated new value
    var val = null;

    // If the optional min was provided, ensure that the decrement action
    // never goes below that value
    if (min != null) {
      // Ensure the value is numeric
      val = Number(tgt());

      // Decrement the value by the step amount
      val -= step;

      // Ensure that the value is not below the min
      if (val < min) {
        val = min;
      }

      // Set the observable value
      tgt(val);
    }
    // Otherwise, if the value is greater than the step amount (step will be min)
    else if (tgt() > step) {
      // Ensure the value is numeric
      val = Number(tgt());

      // Determine how far it is to the next multiple of step
      delta = val % step || step;

      // Set the observable with a new value
      tgt(tgt() - delta);
    }
  };


  /**
   * Increments the forecast wait time by a multiple of the the forecastStep
   *
   * @method unitIncrement
   * @param {Object} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.unitIncrement = function (data, evt) {
    // The event which triggered the action
    var el = evt.target;
    // The name of the observable the action should update
    var elAction = el.getAttribute('data-action');
    // An optional maximum value
    var max = el.getAttribute('data-max');
    // An optional step parameter indicates how granular each step should be
    var step = (el.getAttribute('data-step') != null) ? Number(el.getAttribute('data-step')) : self.forecastStep;
    // Reference to the observable to update
    var tgt = data[elAction];
    // Calculated new value
    var val = null;

    // If the value of the observable is null, set the initial value to 1
    if (!tgt() || tgt() == '') {
      tgt(1);
    }
    // If the optional max was provided, ensure that the increment action never goes above
    // that value
    else if (max) {
      // Ensure the value is numeric
      val = Number(tgt());
      max = Number(max);

      if (val + step > max) {
        tgt(max);
      }
      else {
        tgt(val + (step - val % step));
      }
    }
    else if (Number(tgt()) < 999) {
      val = Number(tgt());
      tgt(val + (step - val % step));
    }
  };

  /**
   * Determines if the user has permissions to summon Consumers
   * out of order
   *
   * @method userCanSummonOutOfOrder
   * @returns {Boolean}
   */
  self.userCanSummonOutOfOrder = ko.computed(function () {
    var admins = [];
    var limitedLocs = [];
    var roles = self.authInfoWS.roles();
    var locs = self.selectedLocations();

    if (roles && roles.length > 0 && locs && locs.length > 0) {
      limitedLocs = locs.filter(function (loc) {
        if (self.hasRole('queueAdmin.location.' + loc.id)) {
          admins.push(loc.id);
        }
        return loc.limitListViewToQueueAdminRole === true;
      });

      return limitedLocs.length === 0 || admins.length > 0;
    }

    return false;
  });


  /**
   * Hides the user menu
   *
   * @method userMenuHide
   * @returns none
   */
  self.userMenuHide = function (data, evt) {
    self.showUserMenu(false);

    if (evt && evt.target.tagName.toLowerCase() == 'button') {
      self.checkStationWS.delegate = null;
    }
  };


  /**
   * Shows the user menu
   *
   * @method userMenuShow
   * @returns none
   */
  self.userMenuShow = function () {
    self.showUserMenu(true);
  };

  /**
   * Determines if the instance has any queues that use audio notifications
   *
   * @method usesAudio
   * @returns {Boolean}
   */
  self.usesAudio = ko.computed(function () {
    // Hook the queues to recalculate once the observable changes
    var queues = self.queues();
    // Iterate over queues, looking for any with audio qualities
    var usesAudio = queues.filter(function (q) {
      return q.audibleAlertsOnEnter || q.audibleAlertsOnCheckIn;
    });
    // Return whether any queues with audio qualities were found
    return usesAudio.length > 0;
  });

  /**
   * Reports if the user and system are configured to show the add
   * consumer button
   *
   * @method canAddConsumer
   * @returns {Boolean}
   */
  self.canAddConsumer = ko.computed(function () {
    // Computed Observable Hooks
    var bundle = self.messagesWS.bundle;
    var roles = self.authInfoWS.roles();

    return self.hasRole('host') && self.messagesWS.get('hideAddConsumerButton') != true;
  });


  /**
   * Determines if the user has the ability to see the
   * summoned customers and can arrive them
   *
   * @method canSeeSummoned
   * @param {String|Number} queueId
   * @returns {Boolean}
   */
  self.canSeeSummoned = function (queueId) {
    var roles = self.authInfoWS.roles();
    var q = self.queuesWS.getQueueById(queueId);

    return !((!self.hasRole('ticketTaker.' + queueId) && q.bridgeCallsWhenSummoned !== true) || q.autoRedeem === true);
  };

  /**
   * Create an observable to poll for selectedLocationIds to store them to local storage w
   * we change locations
   *
   * @method selectedLocationIds.subscribe
   * @returns none
   */
  self.selectedLocationIds.subscribe(function () {
    self.store.set('selectedLocationIds', JSON.stringify(self.selectedLocationIds()), true);
  });

  /**
   * Create an observable to poll for updated information when the queue
   * selection changes
   *
   * @method selectedQueues.subscribe
   * @param {Array} val
   * @returns none
   */
  self.selectedQueues.subscribe(function (val) {
    if (val && val.length > 0) {
      setTimeout(function () {
        self.matchQueueTitleHeight();
      }, 500);
      self.poll();
    }
  });

  /**
   * Create an observable that watches the supportsStationMetadata observable
   * and when it becomes true, issue a checkStationWS request
   *
   * @method supportsStationMetadata.subscribe
   * @returns none
   */
  self.supportsStationMetadata.subscribe(function (val) {
    if (val && val === true) {
      self.checkStationWS.doRequest();
    }
  });

   /**
   * Create subscription to the queues to perform actions to update UI based on available queues provided by the API
   *
   * @method queues.subscribe
   * @returns none
   */
     self.queues.subscribe(function (queues) {
      if (queues.length === 1) {
        self.queueSelectionVM.addQueueId(queues[0].id)
        self.queueSelectionVM.hideQueueList();
      } 
    });


  /** 
   * Restore selected Queues when the application (QueuesWS) first retrieves data
   */
  self.doRestoreSelectedQueues.subscribe(function (doRestore) {
    if (doRestore === true) {
      self.queueSelectionVM.restoreQueuesForLocations();
      self.queueSelectionVM.hideQueueList();
    }
  })



  /**
   * Creates a subscription to the checkStationWS.browserGUID so that when it
   * changes, the settings panel can be presented to the user.
   *
   * @method checkStationWS.browserGUID.subscribe
   * @returns none
   */
  self.checkStationWS.browserGUID.subscribe(function (val) {
    var selectedLocations = self.selectedLocations()
    var locationsHaveClassifiers = selectedLocations && selectedLocations.some(function (location) {
      return location.ticketClassifiers.length > 0
    });
    if (val === null && locationsHaveClassifiers) {
      self.settingsShow();
    }
    else if (self.checkStationWS.delegate != null) {
      // del.execute(null);
    }
  });

  /**
  * Supplemental View Models
  */

  self.addConsumerVM = new AddConsumerViewModel(self);
  self.beginServiceVM = new BeginServiceViewModel(self);
  self.checkInServicedVM = new CheckInServicedViewModel(self);
  self.externalResourcesVM = new ExternalResourcesViewModel(self);
  self.forecastOverrideVM = new ForecastOverrideViewModel(self);
  self.listVM = new ListViewModel(self);
  self.locationSelectionVM = new LocationSelectionViewModel(self);
  self.releaseNotesVM = new ReleaseNotesViewModel(self);
  self.serviceResultVM = new ServiceResultViewModel(self);
  self.consumerDetailVM = new ConsumerDetailViewModel(self);
  self.queueSelectionVM = new QueueSelectionViewModel(self, self.store, self.queuesWS);
  self.settingsVM = new SettingsViewModel(self.userPreferences, self, self.messagesWS, self.stationUpdateWS)
  self.searchVM = new SearchViewModel(self);
  self.servicingVM = new ServicingViewModel(self);

  self.issueTicketOverride = function (spot) {
    self.issueTicketOverrideWS.issueTicketForSpot(spot);
  }

  /**
   * Show the Early Appointment Confirmation (Warning) when an
   * Employee has summoned an Appointment before the Appointment's
   * start time
   */
  self.earlyAppointmentConfirmationShow = function (consumerSessionId) {
    if (!consumerSessionId) {
      return
    }

    // Find the Spot in memory in order to get the Queue ID
    var spot = self
      .queues()
      .reduce(function (spots, queue) {
        return spots.concat(queue.spots());
      }, [])
      .filter(function (spot) {
        return spot.sessionId == consumerSessionId;
      })
      .shift();

    if (spot) {
      self.showConsumerDetail(spot);
      self.consumerDetailVM.earlyAppointmentConfirmationShow(consumerSessionId);
    }
  };

  /**
   * Check if the Employee has chosen a Ticket Classifier at `location`.
   *
   * @param {LocationModel} location
   * @return {Boolean}
   */
  self.employeeNeedsTicketClassifierForLocation = function (location) {
    return (
      !self.checkStationWS.hasBrowserGUID() &&
      location.hasTicketClassifiers()
    );
  };

  /**
   * Watch for changes to the selected queues and perform actions to update the view model.
   *
   * @method selectedQueueIds.subscribe
   * @returns none
   */
  self.queueSelectionVM.selectedQueueIds.subscribe(function (queueIds) { 
    setTimeout(self.matchQueueTitleHeight, 300);
    if (queueIds && queueIds.length >= 1) {
      self.queueSelectionVM.storeQueuesForLocations(self.employeeId(), queueIds);
    }
    self.setSelectedQueueIds(queueIds)
  });

  /**
   * 
   * @param {string} name 
   * @param {Array} enabledValues 
   * @returns 
   */
  this.isFeatureEnabled = function(name, enabledValues) {
    var features = self.featureToggles()

    if (features[name] !== undefined) {
      if (enabledValues && enabledValues.length > 0) {
        return (enabledValues.includes(features[name]))
      } else {
        return features[name]
      }
    }

    return false
  }

  this.isFeatureDisabled = function(name, disabledValues) {
    var features = self.featureToggles()

    if (!features[name]) {
      return true
    }

    if (disabledValues && disabledValues.length > 0) {
      return (disabledValues.includes(features[name]))
    }

    return false
  }

  self.queueWatcher = new QueueWatcher(self.selectedQueues);

  return self;
};

ViewModel.prototype = Object.create(AbstractViewModel.prototype);
ViewModel.prototype.constructor = ViewModel;

ViewModel.prototype._selectConsumer = function selectConsumer(sessionId, queueId) {
  this.selectedConsumerSessionId(sessionId);
  this.selectedConsumerQueueId(queueId);
};

ViewModel.prototype._deselectConsumer = function deselectConsumer() {
  this.selectedConsumerSessionId(null);
  this.selectedConsumerQueueId(null);
};


/**
 * Finds a selected Consumer's Spot
 *
 * @param {string} sessionId the selected consumer's session ID
 * @param {number} queueId the ID of the selected Queue (optional)
 */
ViewModel.prototype.getSpotBySessionId = function findSpot(sessionId, queueId) {
  if (this.showListView()) {
    return this.listVM.getSpotBySessionId(sessionId, queueId);
  }

  var queue = this.queuesWS.getQueueById(queueId);
  if (!queue) {
    return null;
  }

  return queue.getSpotBySessionId(sessionId);
};

// Create a custom bind to restrict inputs to numbers only
ko.bindingHandlers.numeric = {
  init: function (element, valueAccessor) {
    element.addEventListener("keydown", function (event) {
      // Allow: backspace, delete, tab, escape, and enter
      if (
        event.keyCode === 46 ||
        event.keyCode === 8 ||
        event.keyCode === 9 ||
        event.keyCode === 27 ||
        event.keyCode === 13 ||
        // Allow: Ctrl+A
        (event.keyCode === 65 && event.ctrlKey === true) ||
        // Allow: . ,
        event.keyCode === 188 ||
        event.keyCode === 190 ||
        event.keyCode === 110 ||
        // Allow: home, end, left, right
        (event.keyCode >= 35 && event.keyCode <= 39)
      ) {
        // go easy man... let it happen, don't do anything
        return;
      } else {
        // Ensure that it is a number and stop the keypress
        if (
          (event.shiftKey || event.keyCode < 48 || event.keyCode > 57) &&
          (event.keyCode < 96 || event.keyCode > 105)
        ) {
          event.preventDefault();
        }
      }
    });
  }
};


/**
 * Shows desktop notification
 *
 *
 * @returns none
 */
ViewModel.prototype.onQueueEnter = function (queue) {
  var self = this;
  var queueName = queue.name;
  var showDesktopNotifications = self.userPreferences.get('showDesktopNotifications'); 
  var queuesWithNotificationsEnabled = this.userPreferences.get("notificationEnabledQueues");

  if (
    showDesktopNotifications
    && document.visibilityState !== 'visible'
    && this.selectedQueueIds().indexOf(queue.id) !== -1
    && (queuesWithNotificationsEnabled && queuesWithNotificationsEnabled.indexOf(queue.id) !== -1)
  ) {
    var locationName = self.selectedLocations().length > 1 ? self.locationsWS.getLocationById(queue.locationId).description : null;
    showQueueNotification(self.messagesWS, queueName, locationName);
  }
}

ViewModel.prototype.computeRestoreSelectedQueues = function () {
  var queues = this.queuesWS.queues();
  var firstRun = this.queuesWS.isFirstRun();
  return (queues.length > 1 && firstRun) 
}

/**
 * Flips the specified feature on
 * @param {string} feature 
 */
ViewModel.prototype.enableFeature = function (feature) {
  var featureToggles =  this.featureToggles()
  featureToggles[feature] = true;
  this.featureToggles(featureToggles)
}

/**
 * Flips the specified feature off
 * @param {string} feature 
 */
ViewModel.prototype.disableFeature = function (feature) {
  var featureToggles =  this.featureToggles()
  featureToggles[feature] = false;
  this.featureToggles(featureToggles)
}


module.exports = ViewModel
